import React from 'react'

import TotpGuard from '@/app/component/guard/totp'
import Layout from '@/app/component/layout/page'
import { PAGE } from '@/app/definitions'
import { AuthGuard, AuthHeader } from '@/app/module/auth'
import Notifications from '@/app/module/notifications'
import { UserOrganization } from '@/app/module/user'
import { OrganizationTab } from '@/app/module/user/component/organization'

type Props = {
  match: {
    params: {
      tabName?: string
    }
    url: string
  }
}

const OrganizationPage: React.FC<Props> = ({ match }) => {
  const tabName = React.useMemo(() => {
    const tab = match.params.tabName as OrganizationTab | undefined
    if (
      !tab ||
      ![
        OrganizationTab.Audit,
        OrganizationTab.CxUploads,
        OrganizationTab.Info,
        OrganizationTab.Privacy,
        OrganizationTab.Subscription,
        OrganizationTab.Users,
        OrganizationTab.CustomFields,
      ].includes(tab)
    ) {
      return OrganizationTab.Info
    }

    return tab
  }, [match.params.tabName])

  const title = React.useMemo(() => {
    switch (tabName) {
      case OrganizationTab.Audit:
        return 'Organization - Audit Log - engageSPARK'
      case OrganizationTab.CxUploads:
        return 'Organization - Support Uploads - engageSPARK'
      case OrganizationTab.Info:
        return 'Organization - Info - engageSPARK'
      case OrganizationTab.Privacy:
        return 'Organization - Privacy Data - engageSPARK'
      case OrganizationTab.Subscription:
        return 'Organization - Subscription Plan - engageSPARK'
      case OrganizationTab.Users:
        return 'Organization - Users - engageSPARK'
      case OrganizationTab.CustomFields:
        return 'Organization - Custom Fields - engageSPARK'
      default:
        return 'Organization - engageSPARK'
    }
  }, [tabName])

  return (
    <AuthGuard path={match.url} url={match.url}>
      <Layout disableScrolling title={title}>
        <AuthHeader currentPage={PAGE.ACCOUNT.ORGANIZATION.INDEX} />
        <TotpGuard>
          <UserOrganization tabName={tabName} />
        </TotpGuard>
        <Notifications />
      </Layout>
    </AuthGuard>
  )
}

export default OrganizationPage
